/* @flow */
/* eslint max-lines: 0 */

export const COUNTRY = {
    AD: ('AD' : 'AD'),
    AE: ('AE' : 'AE'),
    AG: ('AG' : 'AG'),
    AI: ('AI' : 'AI'),
    AL: ('AL' : 'AL'),
    AM: ('AM' : 'AM'),
    AN: ('AN' : 'AN'),
    AO: ('AO' : 'AO'),
    AR: ('AR' : 'AR'),
    AT: ('AT' : 'AT'),
    AU: ('AU' : 'AU'),
    AW: ('AW' : 'AW'),
    AZ: ('AZ' : 'AZ'),
    BA: ('BA' : 'BA'),
    BB: ('BB' : 'BB'),
    BE: ('BE' : 'BE'),
    BF: ('BF' : 'BF'),
    BG: ('BG' : 'BG'),
    BH: ('BH' : 'BH'),
    BI: ('BI' : 'BI'),
    BJ: ('BJ' : 'BJ'),
    BM: ('BM' : 'BM'),
    BN: ('BN' : 'BN'),
    BO: ('BO' : 'BO'),
    BR: ('BR' : 'BR'),
    BS: ('BS' : 'BS'),
    BT: ('BT' : 'BT'),
    BW: ('BW' : 'BW'),
    BY: ('BY' : 'BY'),
    BZ: ('BZ' : 'BZ'),
    CA: ('CA' : 'CA'),
    CD: ('CD' : 'CD'),
    CG: ('CG' : 'CG'),
    CH: ('CH' : 'CH'),
    CI: ('CI' : 'CI'),
    CK: ('CK' : 'CK'),
    CL: ('CL' : 'CL'),
    CM: ('CM' : 'CM'),
    CN: ('CN' : 'CN'),
    CO: ('CO' : 'CO'),
    CR: ('CR' : 'CR'),
    CV: ('CV' : 'CV'),
    CY: ('CY' : 'CY'),
    CZ: ('CZ' : 'CZ'),
    DE: ('DE' : 'DE'),
    DJ: ('DJ' : 'DJ'),
    DK: ('DK' : 'DK'),
    DM: ('DM' : 'DM'),
    DO: ('DO' : 'DO'),
    DZ: ('DZ' : 'DZ'),
    EC: ('EC' : 'EC'),
    EE: ('EE' : 'EE'),
    EG: ('EG' : 'EG'),
    ER: ('ER' : 'ER'),
    ES: ('ES' : 'ES'),
    ET: ('ET' : 'ET'),
    FI: ('FI' : 'FI'),
    FJ: ('FJ' : 'FJ'),
    FK: ('FK' : 'FK'),
    FM: ('FM' : 'FM'),
    FO: ('FO' : 'FO'),
    FR: ('FR' : 'FR'),
    GA: ('GA' : 'GA'),
    GB: ('GB' : 'GB'),
    GD: ('GD' : 'GD'),
    GE: ('GE' : 'GE'),
    GF: ('GF' : 'GF'),
    GI: ('GI' : 'GI'),
    GL: ('GL' : 'GL'),
    GM: ('GM' : 'GM'),
    GN: ('GN' : 'GN'),
    GP: ('GP' : 'GP'),
    GR: ('GR' : 'GR'),
    GT: ('GT' : 'GT'),
    GW: ('GW' : 'GW'),
    GY: ('GY' : 'GY'),
    HK: ('HK' : 'HK'),
    HN: ('HN' : 'HN'),
    HR: ('HR' : 'HR'),
    HU: ('HU' : 'HU'),
    ID: ('ID' : 'ID'),
    IE: ('IE' : 'IE'),
    IL: ('IL' : 'IL'),
    IN: ('IN' : 'IN'),
    IS: ('IS' : 'IS'),
    IT: ('IT' : 'IT'),
    JM: ('JM' : 'JM'),
    JO: ('JO' : 'JO'),
    JP: ('JP' : 'JP'),
    KE: ('KE' : 'KE'),
    KG: ('KG' : 'KG'),
    KH: ('KH' : 'KH'),
    KI: ('KI' : 'KI'),
    KM: ('KM' : 'KM'),
    KN: ('KN' : 'KN'),
    KR: ('KR' : 'KR'),
    KW: ('KW' : 'KW'),
    KY: ('KY' : 'KY'),
    KZ: ('KZ' : 'KZ'),
    LA: ('LA' : 'LA'),
    LC: ('LC' : 'LC'),
    LI: ('LI' : 'LI'),
    LK: ('LK' : 'LK'),
    LS: ('LS' : 'LS'),
    LT: ('LT' : 'LT'),
    LU: ('LU' : 'LU'),
    LV: ('LV' : 'LV'),
    MA: ('MA' : 'MA'),
    MC: ('MC' : 'MC'),
    MD: ('MD' : 'MD'),
    ME: ('ME' : 'ME'),
    MG: ('MG' : 'MG'),
    MH: ('MH' : 'MH'),
    MK: ('MK' : 'MK'),
    ML: ('ML' : 'ML'),
    MN: ('MN' : 'MN'),
    MQ: ('MQ' : 'MQ'),
    MR: ('MR' : 'MR'),
    MS: ('MS' : 'MS'),
    MT: ('MT' : 'MT'),
    MU: ('MU' : 'MU'),
    MV: ('MV' : 'MV'),
    MW: ('MW' : 'MW'),
    MX: ('MX' : 'MX'),
    MY: ('MY' : 'MY'),
    MZ: ('MZ' : 'MZ'),
    NA: ('NA' : 'NA'),
    NC: ('NC' : 'NC'),
    NE: ('NE' : 'NE'),
    NF: ('NF' : 'NF'),
    NG: ('NG' : 'NG'),
    NI: ('NI' : 'NI'),
    NL: ('NL' : 'NL'),
    NO: ('NO' : 'NO'),
    NP: ('NP' : 'NP'),
    NR: ('NR' : 'NR'),
    NU: ('NU' : 'NU'),
    NZ: ('NZ' : 'NZ'),
    OM: ('OM' : 'OM'),
    PA: ('PA' : 'PA'),
    PE: ('PE' : 'PE'),
    PF: ('PF' : 'PF'),
    PG: ('PG' : 'PG'),
    PH: ('PH' : 'PH'),
    PL: ('PL' : 'PL'),
    PM: ('PM' : 'PM'),
    PN: ('PN' : 'PN'),
    PT: ('PT' : 'PT'),
    PW: ('PW' : 'PW'),
    PY: ('PY' : 'PY'),
    QA: ('QA' : 'QA'),
    RE: ('RE' : 'RE'),
    RO: ('RO' : 'RO'),
    RS: ('RS' : 'RS'),
    RU: ('RU' : 'RU'),
    RW: ('RW' : 'RW'),
    SA: ('SA' : 'SA'),
    SB: ('SB' : 'SB'),
    SC: ('SC' : 'SC'),
    SE: ('SE' : 'SE'),
    SG: ('SG' : 'SG'),
    SH: ('SH' : 'SH'),
    SI: ('SI' : 'SI'),
    SJ: ('SJ' : 'SJ'),
    SK: ('SK' : 'SK'),
    SL: ('SL' : 'SL'),
    SM: ('SM' : 'SM'),
    SN: ('SN' : 'SN'),
    SO: ('SO' : 'SO'),
    SR: ('SR' : 'SR'),
    ST: ('ST' : 'ST'),
    SV: ('SV' : 'SV'),
    SZ: ('SZ' : 'SZ'),
    TC: ('TC' : 'TC'),
    TD: ('TD' : 'TD'),
    TG: ('TG' : 'TG'),
    TH: ('TH' : 'TH'),
    TJ: ('TJ' : 'TJ'),
    TM: ('TM' : 'TM'),
    TN: ('TN' : 'TN'),
    TO: ('TO' : 'TO'),
    TR: ('TR' : 'TR'),
    TT: ('TT' : 'TT'),
    TV: ('TV' : 'TV'),
    TW: ('TW' : 'TW'),
    TZ: ('TZ' : 'TZ'),
    UA: ('UA' : 'UA'),
    UG: ('UG' : 'UG'),
    US: ('US' : 'US'),
    UY: ('UY' : 'UY'),
    VA: ('VA' : 'VA'),
    VC: ('VC' : 'VC'),
    VE: ('VE' : 'VE'),
    VG: ('VG' : 'VG'),
    VN: ('VN' : 'VN'),
    VU: ('VU' : 'VU'),
    WF: ('WF' : 'WF'),
    WS: ('WS' : 'WS'),
    YE: ('YE' : 'YE'),
    YT: ('YT' : 'YT'),
    ZA: ('ZA' : 'ZA'),
    ZM: ('ZM' : 'ZM'),
    ZW: ('ZW' : 'ZW')
};

export const LANG = {
    AR: ('ar' : 'ar'),
    CS: ('cs' : 'cs'),
    DA: ('da' : 'da'),
    DE: ('de' : 'de'),
    EL: ('el' : 'el'),
    EN: ('en' : 'en'),
    ES: ('es' : 'es'),
    FI: ('fi' : 'fi'),
    FR: ('fr' : 'fr'),
    HE: ('he' : 'he'),
    HU: ('hu' : 'hu'),
    ID: ('id' : 'id'),
    IT: ('it' : 'it'),
    JA: ('ja' : 'ja'),
    KO: ('ko' : 'ko'),
    NL: ('nl' : 'nl'),
    NO: ('no' : 'no'),
    PL: ('pl' : 'pl'),
    PT: ('pt' : 'pt'),
    RU: ('ru' : 'ru'),
    SK: ('sk' : 'sk'),
    SV: ('sv' : 'sv'),
    TH: ('th' : 'th'),
    TR: ('tr' : 'tr'),
    ZH: ('zh' : 'zh')
};

export type CountryLangs = {
    AD : 'en' | 'fr' | 'es' | 'zh',
    AE : 'en' | 'fr' | 'es' | 'zh' | 'ar',
    AG : 'en' | 'fr' | 'es' | 'zh',
    AI : 'en' | 'fr' | 'es' | 'zh',
    AL : 'en',
    AM : 'en' | 'fr' | 'es' | 'zh',
    AN : 'en' | 'fr' | 'es' | 'zh',
    AO : 'en' | 'fr' | 'es' | 'zh',
    AR : 'es' | 'en',
    AT : 'de' | 'en',
    AU : 'en',
    AW : 'en' | 'fr' | 'es' | 'zh',
    AZ : 'en' | 'fr' | 'es' | 'zh',
    BA : 'en',
    BB : 'en' | 'fr' | 'es' | 'zh',
    BE : 'en' | 'nl' | 'fr',
    BF : 'fr' | 'en' | 'es' | 'zh',
    BG : 'en',
    BH : 'ar' | 'en' | 'fr' | 'es' | 'zh',
    BI : 'fr' | 'en' | 'es' | 'zh',
    BJ : 'fr' | 'en' | 'es' | 'zh',
    BM : 'en' | 'fr' | 'es' | 'zh',
    BN : 'en',
    BO : 'es' | 'en' | 'fr' | 'zh',
    BR : 'pt' | 'en',
    BS : 'en' | 'fr' | 'es' | 'zh',
    BT : 'en',
    BW : 'en' | 'fr' | 'es' | 'zh',
    BY : 'en',
    BZ : 'en' | 'es' | 'fr' | 'zh',
    CA : 'en' | 'fr',
    CD : 'fr' | 'en' | 'es' | 'zh',
    CG : 'en' | 'fr' | 'es' | 'zh',
    CH : 'de' | 'fr' | 'en',
    CI : 'fr' | 'en',
    CK : 'en' | 'fr' | 'es' | 'zh',
    CL : 'es' | 'en' | 'fr' | 'zh',
    CM : 'fr' | 'en',
    CN : 'zh',
    CO : 'es' | 'en' | 'fr' | 'zh',
    CR : 'es' | 'en' | 'fr' | 'zh',
    CV : 'en' | 'fr' | 'es' | 'zh',
    CY : 'en',
    CZ : 'cs' | 'en' | 'fr' | 'es' | 'zh',
    DE : 'de' | 'en',
    DJ : 'fr' | 'en' | 'es' | 'zh',
    DK : 'da' | 'en',
    DM : 'en' | 'fr' | 'es' | 'zh',
    DO : 'es' | 'en' | 'fr' | 'zh',
    DZ : 'ar' | 'en' | 'fr' | 'es' | 'zh',
    EC : 'es' | 'en' | 'fr' | 'zh',
    EE : 'en' | 'ru' | 'fr' | 'es' | 'zh',
    EG : 'ar' | 'en' | 'fr' | 'es' | 'zh',
    ER : 'en' | 'fr' | 'es' | 'zh',
    ES : 'es' | 'en',
    ET : 'en' | 'fr' | 'es' | 'zh',
    FI : 'fi' | 'en' | 'fr' | 'es' | 'zh',
    FJ : 'en' | 'fr' | 'es' | 'zh',
    FK : 'en' | 'fr' | 'es' | 'zh',
    FM : 'en',
    FO : 'da' | 'en' | 'fr' | 'es' | 'zh',
    FR : 'fr' | 'en',
    GA : 'fr' | 'en' | 'es' | 'zh',
    GB : 'en',
    GD : 'en' | 'fr' | 'es' | 'zh',
    GE : 'en' | 'fr' | 'es' | 'zh',
    GF : 'en' | 'fr' | 'es' | 'zh',
    GI : 'en' | 'fr' | 'es' | 'zh',
    GL : 'da' | 'en' | 'fr' | 'es' | 'zh',
    GM : 'en' | 'fr' | 'es' | 'zh',
    GN : 'fr' | 'en' | 'es' | 'zh',
    GP : 'en' | 'fr' | 'es' | 'zh',
    GR : 'el' | 'en' | 'fr' | 'es' | 'zh',
    GT : 'es' | 'en' | 'fr' | 'zh',
    GW : 'en' | 'fr' | 'es' | 'zh',
    GY : 'en' | 'fr' | 'es' | 'zh',
    HK : 'en' | 'zh',
    HN : 'es' | 'en' | 'fr' | 'zh',
    HR : 'en',
    HU : 'hu' | 'en' | 'fr' | 'es' | 'zh',
    ID : 'id' | 'en',
    IE : 'en' | 'fr' | 'es' | 'zh',
    IL : 'he' | 'en',
    IN : 'en',
    IS : 'en',
    IT : 'it' | 'en',
    JM : 'en' | 'es' | 'fr' | 'zh',
    JO : 'ar' | 'en' | 'fr' | 'es' | 'zh',
    JP : 'ja' | 'en',
    KE : 'en' | 'fr' | 'es' | 'zh',
    KG : 'en' | 'fr' | 'es' | 'zh',
    KH : 'en',
    KI : 'en' | 'fr' | 'es' | 'zh',
    KM : 'fr' | 'en' | 'es' | 'zh',
    KN : 'en' | 'fr' | 'es' | 'zh',
    KR : 'ko' | 'en',
    KW : 'ar' | 'en' | 'fr' | 'es' | 'zh',
    KY : 'en' | 'fr' | 'es' | 'zh',
    KZ : 'en' | 'fr' | 'es' | 'zh',
    LA : 'en',
    LC : 'en' | 'fr' | 'es' | 'zh',
    LI : 'en' | 'fr' | 'es' | 'zh',
    LK : 'en',
    LS : 'en' | 'fr' | 'es' | 'zh',
    LT : 'en' | 'ru' | 'fr' | 'es' | 'zh',
    LU : 'en' | 'de' | 'fr' | 'es' | 'zh',
    LV : 'en' | 'ru' | 'fr' | 'es' | 'zh',
    MA : 'ar' | 'en' | 'fr' | 'es' | 'zh',
    MC : 'fr' | 'en',
    MD : 'en',
    ME : 'en',
    MG : 'en' | 'fr' | 'es' | 'zh',
    MH : 'en' | 'fr' | 'es' | 'zh',
    MK : 'en',
    ML : 'fr' | 'en' | 'es' | 'zh',
    MN : 'en',
    MQ : 'en' | 'fr' | 'es' | 'zh',
    MR : 'en' | 'fr' | 'es' | 'zh',
    MS : 'en' | 'fr' | 'es' | 'zh',
    MT : 'en',
    MU : 'en' | 'fr' | 'es' | 'zh',
    MV : 'en',
    MW : 'en' | 'fr' | 'es' | 'zh',
    MX : 'es' | 'en',
    MY : 'en',
    MZ : 'en' | 'fr' | 'es' | 'zh',
    NA : 'en' | 'fr' | 'es' | 'zh',
    NC : 'en' | 'fr' | 'es' | 'zh',
    NE : 'fr' | 'en' | 'es' | 'zh',
    NF : 'en' | 'fr' | 'es' | 'zh',
    NG : 'en',
    NI : 'es' | 'en' | 'fr' | 'zh',
    NL : 'nl' | 'en',
    NO : 'no' | 'en',
    NP : 'en',
    NR : 'en' | 'fr' | 'es' | 'zh',
    NU : 'en' | 'fr' | 'es' | 'zh',
    NZ : 'en' | 'fr' | 'es' | 'zh',
    OM : 'ar' | 'en' | 'fr' | 'es' | 'zh',
    PA : 'es' | 'en' | 'fr' | 'zh',
    PE : 'es' | 'en' | 'fr' | 'zh',
    PF : 'en' | 'fr' | 'es' | 'zh',
    PG : 'en' | 'fr' | 'es' | 'zh',
    PH : 'en',
    PL : 'pl' | 'en',
    PM : 'en' | 'fr' | 'es' | 'zh',
    PN : 'en' | 'fr' | 'es' | 'zh',
    PT : 'pt' | 'en',
    PW : 'en' | 'fr' | 'es' | 'zh',
    PY : 'es' | 'en',
    QA : 'en' | 'fr' | 'es' | 'zh' | 'ar',
    RE : 'en' | 'fr' | 'es' | 'zh',
    RO : 'en' | 'fr' | 'es' | 'zh',
    RS : 'en' | 'fr' | 'es' | 'zh',
    RU : 'ru' | 'en',
    RW : 'fr' | 'en' | 'es' | 'zh',
    SA : 'ar' | 'en' | 'fr' | 'es' | 'zh',
    SB : 'en' | 'fr' | 'es' | 'zh',
    SC : 'fr' | 'en' | 'es' | 'zh',
    SE : 'sv' | 'en',
    SG : 'en',
    SH : 'en' | 'fr' | 'es' | 'zh',
    SI : 'en' | 'fr' | 'es' | 'zh',
    SJ : 'en' | 'fr' | 'es' | 'zh',
    SK : 'sk' | 'en' | 'fr' | 'es' | 'zh',
    SL : 'en' | 'fr' | 'es' | 'zh',
    SM : 'en' | 'fr' | 'es' | 'zh',
    SN : 'fr' | 'en' | 'es' | 'zh',
    SO : 'en' | 'fr' | 'es' | 'zh',
    SR : 'en' | 'fr' | 'es' | 'zh',
    ST : 'en' | 'fr' | 'es' | 'zh',
    SV : 'es' | 'en' | 'fr' | 'zh',
    SZ : 'en' | 'fr' | 'es' | 'zh',
    TC : 'en' | 'fr' | 'es' | 'zh',
    TD : 'fr' | 'en' | 'es' | 'zh',
    TG : 'fr' | 'en' | 'es' | 'zh',
    TH : 'th' | 'en',
    TJ : 'en' | 'fr' | 'es' | 'zh',
    TM : 'en' | 'fr' | 'es' | 'zh',
    TN : 'ar' | 'en' | 'fr' | 'es' | 'zh',
    TO : 'en',
    TR : 'tr' | 'en',
    TT : 'en' | 'fr' | 'es' | 'zh',
    TV : 'en' | 'fr' | 'es' | 'zh',
    TW : 'zh' | 'en',
    TZ : 'en' | 'fr' | 'es' | 'zh',
    UA : 'en' | 'ru' | 'fr' | 'es' | 'zh',
    UG : 'en' | 'fr' | 'es' | 'zh',
    US : 'en' | 'fr' | 'es' | 'zh',
    UY : 'es' | 'en' | 'fr' | 'zh',
    VA : 'en' | 'fr' | 'es' | 'zh',
    VC : 'en' | 'fr' | 'es' | 'zh',
    VE : 'es' | 'en' | 'fr' | 'zh',
    VG : 'en' | 'fr' | 'es' | 'zh',
    VN : 'en',
    VU : 'en' | 'fr' | 'es' | 'zh',
    WF : 'en' | 'fr' | 'es' | 'zh',
    WS : 'en',
    YE : 'ar' | 'en' | 'fr' | 'es' | 'zh',
    YT : 'en' | 'fr' | 'es' | 'zh',
    ZA : 'en' | 'fr' | 'es' | 'zh',
    ZM : 'en' | 'fr' | 'es' | 'zh',
    ZW : 'en'
};

type CountryMap = {
    [ $Values<typeof COUNTRY> ] : Array<$Values<typeof LANG>>
};

export const COUNTRY_LANGS : CountryMap = {
    [COUNTRY.AD]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.AE]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH, LANG.AR ],
    [COUNTRY.AG]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.AI]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.AL]: [ LANG.EN ],
    [COUNTRY.AM]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.AN]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.AO]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.AR]: [ LANG.ES, LANG.EN ],
    [COUNTRY.AT]: [ LANG.DE, LANG.EN ],
    [COUNTRY.AU]: [ LANG.EN ],
    [COUNTRY.AW]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.AZ]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.BA]: [ LANG.EN ],
    [COUNTRY.BB]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.BE]: [ LANG.EN, LANG.NL, LANG.FR ],
    [COUNTRY.BF]: [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ],
    [COUNTRY.BG]: [ LANG.EN ],
    [COUNTRY.BH]: [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.BI]: [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ],
    [COUNTRY.BJ]: [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ],
    [COUNTRY.BM]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.BN]: [ LANG.EN ],
    [COUNTRY.BO]: [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ],
    [COUNTRY.BR]: [ LANG.PT, LANG.EN ],
    [COUNTRY.BS]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.BT]: [ LANG.EN ],
    [COUNTRY.BW]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.BY]: [ LANG.EN ],
    [COUNTRY.BZ]: [ LANG.EN, LANG.ES, LANG.FR, LANG.ZH ],
    [COUNTRY.CA]: [ LANG.EN, LANG.FR ],
    [COUNTRY.CD]: [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ],
    [COUNTRY.CG]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.CH]: [ LANG.DE, LANG.FR, LANG.EN ],
    [COUNTRY.CI]: [ LANG.FR, LANG.EN ],
    [COUNTRY.CK]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.CL]: [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ],
    [COUNTRY.CM]: [ LANG.FR, LANG.EN ],
    [COUNTRY.CN]: [ LANG.ZH ],
    [COUNTRY.CO]: [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ],
    [COUNTRY.CR]: [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ],
    [COUNTRY.CV]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.CY]: [ LANG.EN ],
    [COUNTRY.CZ]: [ LANG.CS, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.DE]: [ LANG.DE, LANG.EN ],
    [COUNTRY.DJ]: [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ],
    [COUNTRY.DK]: [ LANG.DA, LANG.EN ],
    [COUNTRY.DM]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.DO]: [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ],
    [COUNTRY.DZ]: [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.EC]: [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ],
    [COUNTRY.EE]: [ LANG.EN, LANG.RU, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.EG]: [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.ER]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.ES]: [ LANG.ES, LANG.EN ],
    [COUNTRY.ET]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.FI]: [ LANG.FI, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.FJ]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.FK]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.FM]: [ LANG.EN ],
    [COUNTRY.FO]: [ LANG.DA, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.FR]: [ LANG.FR, LANG.EN ],
    [COUNTRY.GA]: [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ],
    [COUNTRY.GB]: [ LANG.EN ],
    [COUNTRY.GD]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.GE]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.GF]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.GI]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.GL]: [ LANG.DA, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.GM]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.GN]: [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ],
    [COUNTRY.GP]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.GR]: [ LANG.EL, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.GT]: [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ],
    [COUNTRY.GW]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.GY]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.HK]: [ LANG.EN, LANG.ZH ],
    [COUNTRY.HN]: [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ],
    [COUNTRY.HR]: [ LANG.EN ],
    [COUNTRY.HU]: [ LANG.HU, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.ID]: [ LANG.ID, LANG.EN ],
    [COUNTRY.IE]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.IL]: [ LANG.HE, LANG.EN ],
    [COUNTRY.IN]: [ LANG.EN ],
    [COUNTRY.IS]: [ LANG.EN ],
    [COUNTRY.IT]: [ LANG.IT, LANG.EN ],
    [COUNTRY.JM]: [ LANG.EN, LANG.ES, LANG.FR, LANG.ZH ],
    [COUNTRY.JO]: [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.JP]: [ LANG.JA, LANG.EN ],
    [COUNTRY.KE]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.KG]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.KH]: [ LANG.EN ],
    [COUNTRY.KI]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.KM]: [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ],
    [COUNTRY.KN]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.KR]: [ LANG.KO, LANG.EN ],
    [COUNTRY.KW]: [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.KY]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.KZ]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.LA]: [ LANG.EN ],
    [COUNTRY.LC]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.LI]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.LK]: [ LANG.EN ],
    [COUNTRY.LS]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.LT]: [ LANG.EN, LANG.RU, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.LU]: [ LANG.EN, LANG.DE, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.LV]: [ LANG.EN, LANG.RU, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.MA]: [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.MC]: [ LANG.FR, LANG.EN ],
    [COUNTRY.MD]: [ LANG.EN ],
    [COUNTRY.ME]: [ LANG.EN ],
    [COUNTRY.MG]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.MH]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.MK]: [ LANG.EN ],
    [COUNTRY.ML]: [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ],
    [COUNTRY.MN]: [ LANG.EN ],
    [COUNTRY.MQ]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.MR]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.MS]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.MT]: [ LANG.EN ],
    [COUNTRY.MU]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.MV]: [ LANG.EN ],
    [COUNTRY.MW]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.MX]: [ LANG.ES, LANG.EN ],
    [COUNTRY.MY]: [ LANG.EN ],
    [COUNTRY.MZ]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.NA]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.NC]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.NE]: [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ],
    [COUNTRY.NF]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.NG]: [ LANG.EN ],
    [COUNTRY.NI]: [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ],
    [COUNTRY.NL]: [ LANG.NL, LANG.EN ],
    [COUNTRY.NO]: [ LANG.NO, LANG.EN ],
    [COUNTRY.NP]: [ LANG.EN ],
    [COUNTRY.NR]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.NU]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.NZ]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.OM]: [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.PA]: [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ],
    [COUNTRY.PE]: [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ],
    [COUNTRY.PF]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.PG]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.PH]: [ LANG.EN ],
    [COUNTRY.PL]: [ LANG.PL, LANG.EN ],
    [COUNTRY.PM]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.PN]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.PT]: [ LANG.PT, LANG.EN ],
    [COUNTRY.PW]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.PY]: [ LANG.ES, LANG.EN ],
    [COUNTRY.QA]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH, LANG.AR ],
    [COUNTRY.RE]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.RO]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.RS]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.RU]: [ LANG.RU, LANG.EN ],
    [COUNTRY.RW]: [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ],
    [COUNTRY.SA]: [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.SB]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.SC]: [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ],
    [COUNTRY.SE]: [ LANG.SV, LANG.EN ],
    [COUNTRY.SG]: [ LANG.EN ],
    [COUNTRY.SH]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.SI]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.SJ]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.SK]: [ LANG.SK, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.SL]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.SM]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.SN]: [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ],
    [COUNTRY.SO]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.SR]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.ST]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.SV]: [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ],
    [COUNTRY.SZ]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.TC]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.TD]: [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ],
    [COUNTRY.TG]: [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ],
    [COUNTRY.TH]: [ LANG.TH, LANG.EN ],
    [COUNTRY.TJ]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.TM]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.TN]: [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.TO]: [ LANG.EN ],
    [COUNTRY.TR]: [ LANG.TR, LANG.EN ],
    [COUNTRY.TT]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.TV]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.TW]: [ LANG.ZH, LANG.EN ],
    [COUNTRY.TZ]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.UA]: [ LANG.EN, LANG.RU, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.UG]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.US]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.UY]: [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ],
    [COUNTRY.VA]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.VC]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.VE]: [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ],
    [COUNTRY.VG]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.VN]: [ LANG.EN ],
    [COUNTRY.VU]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.WF]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.WS]: [ LANG.EN ],
    [COUNTRY.YE]: [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.YT]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.ZA]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.ZM]: [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ],
    [COUNTRY.ZW]: [ LANG.EN ]
};

export type LocaleType = {
    country : $Values<typeof COUNTRY>,
    lang : $Values<typeof LANG>
};
